'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var _tslib = require('../_tslib-bcbe0269.js');

var core = require('@emotion/core');

var React = require('react');

var React__default = _interopDefault(React);

var IconTwitter = React__default.forwardRef(function (_a, ref) {
  var _b = _a.fill,
      _c = _a.stroke,
      _d = _a.weight,
      props = _tslib.__rest(_a, ["fill", "stroke", "weight"]);

  return core.jsx("svg", _tslib.__assign({
    viewBox: "0 0 24 24",
    ref: ref,
    css: core.css(templateObject_1 || (templateObject_1 = _tslib.__makeTemplateObject(["\n        * {\n          vector-effect: non-scaling-stroke;\n        }\n        overflow: visible;\n        height: 24px;\n      "], ["\n        * {\n          vector-effect: non-scaling-stroke;\n        }\n        overflow: visible;\n        height: 24px;\n      "])))
  }, props), core.jsx("path", {
    fill: "currentColor",
    d: "M23.32 6.44a.5.5 0 0 0-.2-.87l-.79-.2a.5.5 0 0 1-.33-.7l.44-.89a.501.501 0 0 0-.58-.7l-2 .56a.502.502 0 0 1-.44-.08 5 5 0 0 0-8 4v.36a.25.25 0 0 1-.22.25c-2.81.33-5.5-1.1-8.4-4.44a.508.508 0 0 0-.51-.15A.5.5 0 0 0 2 4a7.575 7.575 0 0 0 .46 4.92.25.25 0 0 1-.26.36l-1.12-.22a.5.5 0 0 0-.57.59 5.15 5.15 0 0 0 2.37 3.78.25.25 0 0 1 0 .45l-.53.21a.5.5 0 0 0-.26.69 4.36 4.36 0 0 0 3.2 2.48.25.25 0 0 1 0 .47c-1.36.562-2.819.845-4.29.83a.51.51 0 0 0-.2 1 20.063 20.063 0 0 0 8.14 1.93 12.58 12.58 0 0 0 7-2A12.5 12.5 0 0 0 21.5 9.06v-.87a.499.499 0 0 1 .18-.38l1.64-1.37z"
  }));
});
var templateObject_1;
exports.IconTwitter = IconTwitter;